// extracted by mini-css-extract-plugin
export default {"tasks":"LL-z","task":"ML-z","svg":"NL-z","text":"OL-z"};